<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="800">
    <template v-slot:title>{{ title }}</template>
    <supplier-commission-receipt-list
      :itineraryItem="value"
    ></supplier-commission-receipt-list>
    <v-row v-if="debug">
      <v-col
        ><code>{{ value ? value.id : "" }}</code></v-col
      >
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import SupplierCommissionReceiptList from "./SupplierCommissionReceiptList.vue";

export default {
  name: "supplier-commission-receipts",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: { BasicDialog, SupplierCommissionReceiptList },

  data() {
    return {
      debug: false,
    };
  },

  computed: {
    title() {
      return this.value
        ? `${this.value.supplierName} - ${this.value.serviceName}`
        : "";
    },
    itiItemId() {
      return this.value ? this.value.id : null;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/finances/supplier-commission-receipts/SupplierCommissionReceiptsDialog.vue